export const wattAmTagBellCurve = {
    WattAmTagBellCurveClass: {
        url: "Diagramm/bellcurve",
        defaultSegment: "Diagramm",
        forceRefresh: false,
        receiveType: 'RECEIVE_WattAmTagBellCurve_wattAmTagBellCurveReducer'
    }
};
